<template>
  <div class="relative group">
    <Link
      :href="href"
      :method="method"
      :as="as"
      :title="collapsed && !forceExpanded ? label : ''"
      class="pointer-events-auto group flex items-center gap-3 px-3 py-2.5 rounded-xl select-none transition-all duration-200"
      :class="[
        active
          ? 'bg-blue-50 text-blue-600 dark:bg-slate-700 dark:text-white shadow-inner'
          : 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800',
        collapsed && !forceExpanded ? 'justify-center px-2' : ''
      ]"
    >
      <component
        :is="icon"
        class="w-5 h-5 transition-colors shrink-0"
        :class="active
          ? 'text-blue-600 dark:text-white'
          : 'text-slate-500 group-hover:text-slate-700 dark:text-slate-400 dark:group-hover:text-slate-200'"
      />

      <span v-show="!collapsed || forceExpanded" class="truncate">{{ label }}</span>
    </Link>

    <!-- Tooltip only when collapsed -->
    <div
      v-if="collapsed && !forceExpanded"
      class="pointer-events-none absolute left-[78px] top-1/2 -translate-y-1/2 opacity-0
             group-hover:opacity-100 transition-all duration-150 z-[999]
             whitespace-nowrap text-xs font-medium rounded-md px-2 py-1 shadow-lg
             bg-white text-slate-700 dark:bg-slate-800 dark:text-slate-100 border border-slate-200"
    >
      {{ label }}
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: { Link },
  props: {
    href: { type: String, required: true },
    label: { type: String, required: true },
    icon: { type: [Object, String, Function], default: null },
    active: { type: Boolean, default: false },
    collapsed: { type: Boolean, default: false },
    forceExpanded: { type: Boolean, default: false }, // 👈 from Collapse
    method: { type: String, default: 'get' }, // allows delete for logout
    as: { type: String, default: 'a' },
  },
}
</script>
